import * as angular from "angular";
import {ILogService, IPromise, IQService} from "angular";
import {ModelListWithCursor} from "../../commons/angular/models/model-list-with-cursor.model";
import {GeofenceZoneRequests} from "./geofence-zone-requests.service";
import {GeofenceZonesAlerts} from "./geofence-zones-alerts.service";
import {GeofenceLocationType, GeofenceZone, GeofenceZonesQueryParams} from "../models/geofence-zone.model";

export class GeofenceZonesService {

  /* @ngInject */
  constructor(private geofenceZoneRequests: GeofenceZoneRequests,
              private geofenceZonesAlerts: GeofenceZonesAlerts,
              private $log: ILogService,
              private $q: IQService) {
  }

  getAll(params?: GeofenceZonesQueryParams): IPromise<ModelListWithCursor<GeofenceZone>> {
    const deferred = this.$q.defer<ModelListWithCursor<GeofenceZone>>();

    this.geofenceZoneRequests.getAll(params)
      .then((page) => deferred.resolve(page))
      .catch((error) => {
        this.$log.error('Failed to get geofence zones @geofenceZonesService@getAll', error);
        this.geofenceZonesAlerts.getManyError();
        deferred.reject(error);
      });

    return deferred.promise;
  }

  create(locationType: GeofenceLocationType, locationId: string, zone: GeofenceZone): IPromise<GeofenceZone> {
    const deferred = this.$q.defer<GeofenceZone>();

    this.geofenceZoneRequests.create(locationType, locationId, zone)
      .then((created) => {
        this.geofenceZonesAlerts.createSuccess();
        deferred.resolve(created);
      })
      .catch((error) => {
        this.$log.error('Failed to create geofence zone @geofenceZonesService@create', error);
        this.geofenceZonesAlerts.createError();
        deferred.reject(error);
      });

    return deferred.promise;
  }

  update(geofenceZoneId: string, zone: GeofenceZone): IPromise<GeofenceZone> {
    const deferred = this.$q.defer<GeofenceZone>();

    this.geofenceZoneRequests.update(geofenceZoneId, zone)
      .then((updated) => {
        this.geofenceZonesAlerts.updateSuccess();
        deferred.resolve(updated);
      })
      .catch((error) => {
        this.$log.error('Failed to update geofence zone @geofenceZonesService@update', error);
        this.geofenceZonesAlerts.updateError();
        deferred.reject(error);
      });

    return deferred.promise;
  }

  deleteOne(geofenceZoneId: string): IPromise<void> {
    const deferred = this.$q.defer<void>();

    this.geofenceZoneRequests.deleteOne(geofenceZoneId)
      .then(() => {
        this.geofenceZonesAlerts.removeSuccess();
        deferred.resolve();
      })
      .catch((error) => {
        this.$log.error('Failed to delete geofence zone @geofenceZonesService@deleteOne', error);
        this.geofenceZonesAlerts.removeError();
        deferred.reject(error);
      });

    return deferred.promise;
  }
}

angular
  .module('bringoz.admin.service-areas')
  .service('geofenceZonesService', GeofenceZonesService);
